import React, {useState} from 'react'
import { Form, Input, Button, Col, message, Tooltip, Icon } from 'antd';
import { UPDATE_PASSWORD } from '../../constants/graphql-query';
import { useMutation } from 'react-apollo';
import { useTranslation } from 'react-i18next';

const UpdatePasswordForm = (props) => {

    const {form, data} = props;

    let { t } = useTranslation();
    
    const { getFieldDecorator } = form;
    
    const [updatePassword] = useMutation(UPDATE_PASSWORD, {
        fetchPolicy: 'no-cache',
        errorPolicy: 'all',
        onCompleted: ( data ) => {
            if(data) {
                message.destroy();
                message.success(data.changePassword.msg);
                form.resetFields()
            }
		},
		onError: (error) => {
			message.destroy();
			message.error('"Something went wrong !"');
		}
      });

    const handleSubmit = e => {
        e.preventDefault();

        form.validateFields((err, fieldsValue) => {
            if (err) {
                return;
            }

            let userDetails = data.user;
            message.loading('Updating.. Please wait..', 0);
            updatePassword({
                variables: {
                    userId: userDetails.logonId,
                    password: fieldsValue["oldPassword"],
                    newPassword: fieldsValue["newPassword"],
                }
            })
        });
    };

    const formReset = () => {
        form.resetFields()
    }
    
    const [state, setState] = useState({
        confirmDirty: false
    })

    const config = (input, extRules = {}) => ({
        rules: [
            { required: true, message: `Please Enter ${input}` },
            extRules
        ],
    });
    const handleConfirmBlur = e => {
        const { value } = e.target;
        setState({ confirmDirty: state.confirmDirty || !!value });
    };

    const compareToFirstPassword = (rule, value, callback) => {
        if (value && value !== form.getFieldValue('newPassword')) {
            callback('Two passwords that you enter is inconsistent!');
        } else {
            callback();
        }
    };

    const validateToNextPassword = (rule, value, callback) => {
        const { form } = props;
        const password = form.getFieldValue("newPassword");
        const matchpassword = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\s).{10,128}$/;
        if (password && !password.match(matchpassword)) {
            callback(t("form.passwordPolicy"));
        }
        
        if (value && state.confirmDirty) {
            form.validateFields(['confirmPassword'], { force: true });
        }

        callback();
    };

    return (
        <div>
            <Form layout="vertical" className="password-reset-form" onSubmit={handleSubmit}>
                <Col span={24}>
                    <Form.Item label="Old Password:">
                        {getFieldDecorator('oldPassword', config('Old Password'))(<Input type="password" />)}
                    </Form.Item>
                </Col>
                <Col span={24}>
                    <Form.Item label="New Password:">
                        {getFieldDecorator(
                            'newPassword',
                            config(
                                'New Password',
                                {
                                    validator: validateToNextPassword
                                }
                            )
                        )(
                            <Input
                                type="password"
                                suffix={
                                    <Tooltip title={t("form.passwordPolicy")}>
                                      <Icon type="info-circle" />
                                    </Tooltip>
                                }
                            />
                        )}
                    </Form.Item>
                </Col>
                <Col span={24}>
                    <Form.Item label="Confirm Password:">
                        {getFieldDecorator(
                            'confirmPassword',
                            config(
                                'Confirm Password',
                                {
                                    validator: compareToFirstPassword
                                }
                            )
                        )(
                            <Input
                                type="password"
                                onBlur={handleConfirmBlur}
                                suffix={
                                    <Tooltip title={t("form.passwordPolicy")}>
                                      <Icon type="info-circle" />
                                    </Tooltip>
                                }
                            />
                        )}
                    </Form.Item>
                </Col>
                <Col span={24}>
                    <Form.Item>
                        <Button type="primary" htmlType="submit" className="primary-dark">Update Password</Button>
                        <Button onClick={formReset} className="ml-10">Clear </Button>
                    </Form.Item>
                </Col>
            </Form>
        </div>
    )
}

const UpdatePasswordWithForm = Form.create({ name: 'UpdatePasswordWithForm' })(UpdatePasswordForm);

export default UpdatePasswordWithForm;